import { useContext, useEffect, useState } from 'react';
import { useLoaderData, useLocation, useNavigate } from 'react-router-dom';
import { useImmerReducer } from 'use-immer';
import PageBuilder from '../../../../library/Builders/PageBuilder/PageBuilder';
import { GlobalContext } from '../../../../library/Core/GlobalContext';
import { SmartContext } from '../../../../library/Core/SmartContext';
import smartReducer from '../../../../library/Core/SmartReducer';
import { DispatchEvent, State } from '../../../../library/Core/SmartTypes';
import { addUserSpecificDomains } from '../../../../library/Service/domainService';
import { handleCompleteLater, handleNext, onCurrentJobSelectionChange } from './FreeLancingWorkActions';
import { onPrimaryCurrentChange } from '../primaryCurrentJob';
import FreeLancingWorkLayout from './FreeLancingWorkLayout';
import ProfilePicturePageConfig from '../ProfilePicturePageConfig.json';
import CurrentJobInformationLayout from '../CurrentJobInformationLayout';

const FreeLancingWork = () => {
    const { globalState } = useContext(GlobalContext);
    const navigate = useNavigate();
    const [redirectUrl, setRedirectUrl] = useState('');

    const location = useLocation();
    const currentMatch = location.pathname.includes('current')

    const [state, dispatch] = useImmerReducer<State, DispatchEvent>(smartReducer, {
        flags: { isDataLoading: true, showFormErrors: 0 },
        formValidationErrors: {},
        actions: {
            NEXT: handleNext,
            I_LL_DO_THIS_LATER: handleCompleteLater,
            ROUTER_NAVIGATE: navigate,
            isCurrent: onCurrentJobSelectionChange,
            isPrimaryCurrent: onPrimaryCurrentChange('freelancing'),
            REDIRECT: setRedirectUrl
        },
    } as any);

    const { formConfig, data, routeInfo } = useLoaderData() as State;

    let message = `In your work status, you mentioned that you are currently self-employed. Please provide the details of your self-employment`

    useEffect(() => {
        const domain = addUserSpecificDomains(new Map([...globalState.domain]), data);

            const jobRoleCodeDomain = domain.get('FREELANCING_JOB_ROLE_CODE');
            if (jobRoleCodeDomain) {
                domain.set('JOB_ROLE_CODE', jobRoleCodeDomain);
            }

            // This code for Profile Picture Section from config----------
            let updatedFormConfig: any = { ...formConfig };
            console.log("currentMatch",currentMatch)
            if (currentMatch) {
                const rawProfileSection =
                    ProfilePicturePageConfig.sectionRepository.find(
                        (sec: any) => sec.id === "profile"
                    );
                console.log("rawProfileSection",rawProfileSection)
                if (rawProfileSection && !updatedFormConfig.sections?.includes("profile")) {
                    updatedFormConfig = {
                        ...updatedFormConfig,
                        sections: [...(updatedFormConfig.sections ?? []), "profile"],
                        sectionRepository: [
                            ...(updatedFormConfig.sectionRepository ?? []),
                            rawProfileSection as any
                        ],
                    };
                }
            }
            // end here

            const updatedFreelancingWork = (data?.freelancing?.length
                ? data.freelancing
                : [{}]
            ).map((job: any) => ({
                ...job,
                isCurrent: currentMatch ?  true : job?.isCurrent ?? 0
            }));

        dispatch({
            type: 'DATA_INIT',
            payload: {
                formConfig: updatedFormConfig,
                data: {
                    ...data,
                    freelancing: updatedFreelancingWork,
                    currentMatch
                },
                domain,
                routeInfo,
            },
        });
    }, []);
  
    useEffect(() => {
        if (redirectUrl !== '') {
            navigate(redirectUrl);
        }
    }, [redirectUrl]);

    const LayoutComponent = currentMatch ? CurrentJobInformationLayout : FreeLancingWorkLayout;

    return (
        <SmartContext.Provider value={{ state, dispatch }}>
            <LayoutComponent> {!state.flags.isDataLoading && <PageBuilder data={message} />}</LayoutComponent>
        </SmartContext.Provider>
    );
};

export default FreeLancingWork;
